module.exports = __webpack_public_path__ + "static/media/Message_Chat_Box@3x.dfdc145e.png";